<gtw-confirmation-modal
  [config]="confirmConfig"
  [visible]="false"
  (confirmed)="refresh()"
  (cancelled)="cancel()"
  (closed)="cancel()"
></gtw-confirmation-modal>
